import React from 'react';
import { useSelector } from 'react-redux';

const Logo = props => {
  const logoUrl = useSelector(state => state.product.logo);
  return logoUrl && <img src={logoUrl} alt="" {...props} />;
};

export default Logo;
